// extracted by mini-css-extract-plugin
export var container = "_b4-0";
export var icon = "_b4-1";
export var text = "_b4-2";